<template>
  <div id="login" class="c-forgot c-page">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline">
          <strong>Har du</strong> en rabatkode?
        </h1>
      </div>

      <div class="l-tablet-column--6">
        <div v-if="errorMessage" class="c-error">
          <p
            :class="{ 'c-error__text': !formValid, 'c-input-valid__text': formValid }"
          >{{ errorMessage }}</p>
        </div>

        <form class="c-form general-form">
          <input
            v-model="input.coupon"
            class="c-form__element"
            type="text"
            name="coupon"
            placeholder="Rabatkode"
          />

          <label class="c-form__submit" @click.prevent="addCoupon()">
            <SpinnerButton
              ref="request"
              class="c-form__submit"
              cta="Indløs rabatkode"
              action="Indløser rabatkode"
            />

            <input type="submit" value="Login" />
          </label>

          <!-- <SpinnerButton
            ref="request"
            cta="Nulstil kodeord"
            action="Nulstiller"
            class="c-form__submit"
            @clickaction="requestPassword"
          />-->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import CouponResponse from "@/components/CouponResponse.js";
import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "Coupon",
  components: {
    SpinnerButton
  },
  mixins: [CouponResponse],
  data() {
    return {
      errorMessage: "",
      formValid: false,
      input: {
        coupon: this.$route.params.coupon || ""
      }
    };
  },
  methods: {
    addCoupon() {
      //const validation = this.formalValidation();

      console.log("add");
      console.log(this.input.coupon);
      this.$userService
        .addCoupon(this.input.coupon)
        .then(data => {
          //if (data)
          console.log(data);
          console.log(this.$userService.user);

          if (data.status == 200) {
            const coupon = data.data;
            const status_text = this.couponSuccessResponse(coupon);

            this.handleError({
              valid: true,
              error: status_text
            });
          }

          this.$router.push({ name: "welcome" }, () => {
            return;
          });
        })
        .catch(error => {
          // Handle error
          console.log("catch", error);
          this.$refs.request.reset();
          this.handleError({
            valid: false,
            error: "Vi kan ikke genkende den kode. Beklager."
          });
        });
    },
    handleError(error) {
      this.formValid = error.valid;
      this.$refs.request.reset();
      this.errorMessage = error.error;
      console.log(error);
    }
  }
};
</script>